module.exports = __webpack_public_path__ + "assets/img/envelope-fail-5d342692b4b89ff77d48fc4ea24a379b.svg";